import React from 'react';
import {TabbedOverviewPage, ReadinessScoreStructureSection, ScoreStructureSection} from '../components/OverviewSections.comp';
import {useAuth} from '../../../context/auth';
import {DQ_PRO_PLAN_KEY} from '../../../utils/constants';
import {solutionPlanKey} from '../../../utils/productAccess';

const AboutRubricsScoresPage = () => {
    const {authUser} = useAuth();
    // A direct plan shows its enterprise plan's scores (solutionPlanKey).
    const planKey = solutionPlanKey(authUser?.dq_pro_plan?.plan_key);
    const showReadinessScores = planKey === DQ_PRO_PLAN_KEY.ENTERPRISE_P1 || planKey === DQ_PRO_PLAN_KEY.ENTERPRISE_LC;
    const showChildrenAssessmentScores = planKey === DQ_PRO_PLAN_KEY.ENTERPRISE_P0 || planKey === DQ_PRO_PLAN_KEY.ENTERPRISE_P1;

    const tabs = [
        showReadinessScores && {
            label: 'COS Readiness Solution Scores',
            content: <ReadinessScoreStructureSection/>,
        },
        showChildrenAssessmentScores && {
            label: 'COS Children Assessment Scores',
            content: <ScoreStructureSection/>,
        },
    ].filter(Boolean);

    // Static Common Section content — shown even before the partner has dashboard data.
    return <TabbedOverviewPage skipNoDataGate tabs={tabs.length > 0 ? tabs : [{label: 'COS Children Assessment Scores', content: <ScoreStructureSection/>}]}/>;
};

export default AboutRubricsScoresPage;
